var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-ueditor-wrap',{ref:"ueditor",attrs:{"destroy":false,"config":_vm.config},on:{"beforeInit":_vm.addCustomUI},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }